// Combine rapid picker edits; stop superseded HTTP requests instead of merely
// ignoring their responses. Callers retain their active-response guard.
export function scheduleDashboardRequest(run, delay = 300) {
  const controller = new AbortController();
  const timer = setTimeout(() => run(controller.signal), delay);
  return () => {
    clearTimeout(timer);
    controller.abort();
  };
}
